import { useFormContext } from "@jti/ui";
export const useShippingFormContext = () => useFormContext();
//# sourceMappingURL=useShippingFormContext.js.map